import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDnsDetails, addSubdomains } from "../../actions/sub-domain";
import "../../assets/css/recommendation-modal.css";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import BasicLineColumn from "../common/apexChart/lineChart";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import { Link, useParams } from "react-router-dom";
import $, { data } from "jquery";

const Domain = () => {
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const myRef = useRef(null);
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(20);

  const [filterData, setfilterData] = useState("all");
  const [domainFilter, setDomainFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');

  const queryParameters = new URLSearchParams(window.location.search);
  const [Ips, setIps] = useState([]);
  const latest = queryParameters.get("latest");

  if (latest && filterData == "all")
    setfilterData("Latest")

  // const id = JSON.parse(localStorage.getItem("user")).organisationId;
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  }); let dnsDetailsArray = useSelector(
    (state) => state.subDomain?.dnsDetails?.data
  );
  let oldDnsDetails = useSelector(
    (state) => state.subDomain?.dnsDetails?.scanDetailArray
  );

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  const auth = useSelector((state) => state?.auth?.user);
  const [isModalThree, setModalThree] = useState(false);
  let domain = client?.website?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
  if (domain?.charAt(domain.length - 1) == "/") {
    domain = [domain.substr(0, domain.length - 1)];
    // domain.unshift("all");
  } else {
    domain = [domain];
    // domain.unshift("all");
  }
  if (client?.domains && client.domains.length > 0) {
    domain = client.domains;
    // domain.unshift("all");
  }
  let scanCompleted = useSelector((state) => state.subDomain?.scanCompleted);


  useEffect(() => {
    if (orgId) {
      getDnsDetails(orgId, false, dispatch);
    } else getDnsDetails(id, false, dispatch);
  }, [id]);

  // let filterEntry = ["all",  "Last 30 days"];

  const filterValue = dnsDetailsArray?.map((row) => row?.recordType);
  let distinctFilter = filterValue?.filter(
    (item, index, self) => self.indexOf(item) === index
  );

  distinctFilter?.unshift("all");
  distinctFilter?.push("Latest");

  const issuesFound = dnsDetailsArray?.filter(
    (row) =>
      row?.recordType == "spf" &&
      !row?.valid &&
      row?.record?.indexOf("SPF TXT record") == -1 &&
      row?.record?.indexOf("does not exist") == -1
  );
  const warningFound = dnsDetailsArray?.filter(
    (row) =>
      (row?.recordType == "dmarc" && !row?.valid) ||
      (row?.recordType == "MX" && row?.hosts?.length > 0 && !row?.valid)
  );

  // const compliantData = dnsDetailsArray?.filter((row) => row?.valid);

  // let compliantDataPercentage = compliantData?.length / dnsDetailsArray?.length;


  let openPortArray = [];
  let ipArray = [];
  // if (oldDnsDetails?.scanDetails) {
  //   const compliantDataOld = oldDnsDetails?.scanDetails?.filter(
  //     (row) => row?.valid
  //   );
  //   let compliantDataOldPercentage =
  //     (compliantDataOld?.length / oldDnsDetails?.scanDetails?.length) * 100;
  //   ipArray.push(oldDnsDetails?.scanDetails?.length || 0);
  //   openPortArray.push(compliantDataOldPercentage?.toFixed(0));
  // }
  for (let count = 0; count < oldDnsDetails?.scanDetails?.length; count++) {
    const compliantDataOld = oldDnsDetails?.scanDetails?.[count]?.filter(
      (row) => row?.valid
    );
    let compliantDataOldPercentage =
      (compliantDataOld?.length / oldDnsDetails?.scanDetails?.[count]?.length) * 100;
    ipArray.push(oldDnsDetails?.scanDetails?.[count]?.length || 0);
    openPortArray.push(compliantDataOldPercentage?.toFixed(0));
  }
  // if (dnsDetailsArray) {
  //   ipArray.push(dnsDetailsArray?.length);
  //   openPortArray.push((compliantDataPercentage * 100).toFixed(0));
  // }


  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
  };

  const downloadCsvData = dnsDetailsArray?.map((res) => ({
    DomainName: res?.subDomain,
    RecordType: res?.recordType,
    Record: JSON.stringify(
      res?.recordType == "MX"
        ? res.valid
          ? res?.hosts?.map((row) => row[0]?.hostname)
          : res?.warnings?.map((row) => row?.hostname)
        : res?.record
    )?.replace(/[\[\]']+/g, "")?.replace(/['"]+/g, ""),
    LastUpdated: moment(res?.createdAt).format("DD-MM-YYYY"),
  }));

  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll
  };


  let newAddedDomain = [];
  if (client?.scanCounter > 0) {
    let oldScanData = oldDnsDetails?.scanDetails[client?.scanCounter - 1];
    for (let vuln = 0; vuln < dnsDetailsArray?.length; vuln++) {
      let flag = true;
      for (let oldVuln = 0; oldVuln < oldScanData?.length; oldVuln++) {
        if (dnsDetailsArray[vuln].subDomain == oldScanData[oldVuln].subDomain && dnsDetailsArray[vuln].recordType == oldScanData[oldVuln].recordType) {
          flag = false;
          break;
        }
      }
      if (flag) {
        newAddedDomain.push(dnsDetailsArray[vuln])
      }
    }
  }

  if (domainFilter !== "all") {
    dnsDetailsArray = dnsDetailsArray?.filter((val) => val?.subDomain.indexOf(domainFilter) != -1)
  }

  let mapData =
    filterData === "all"
      ? dnsDetailsArray
      : filterData === "Issues"
        ? issuesFound
        : filterData === "Warnings"
          ? warningFound
          : filterData === "Last 30 days"
            ? recordAddedInLast30Days
            : filterData === "Latest"
              ? newAddedDomain
              : dnsDetailsArray?.filter((row) => row?.recordType == filterData);

  // mapData = mapData?.filter((row) => ((row?.recordType == "spf" && (row?.record?.indexOf("SPF TXT record") == -1 && row?.record?.indexOf("does not exist") == -1)) || (((row?.recordType == "dmarc" && !row?.valid) || (row?.recordType == "MX" && row?.hosts?.length > 0 && !row?.valid)))))

  const recordAddedInLast30Days = mapData?.filter(
    (row) =>
      moment(row?.createdAt).isBefore(moment()) &&
      moment(row?.createdAt).isAfter(moment().subtract(90, "days"))
  );

  mapData = mapData?.filter((res) => {
    if (search === "") {
      return res;
    } else if (
      res?.recordType?.toLowerCase()?.indexOf(search.toLowerCase()) != -1 ||
      res?.subDomain?.toLowerCase()?.indexOf(search.toLowerCase()) != -1
    ) {
      // (res?.records?.map((row) => row.indexOf(search) != -1)) )
      return res;
    }
  });

  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    const firstPageIndex = (page - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    currentTableData = mapData?.slice(firstPageIndex, lastPageIndex);
  }

  const removeKeyword = (index) => {
    let ip = [...Ips];
    ip.splice(index, 1);
    setIps(ip);
  }

  const addIps = () => {
    let val = $("#ips").val()
    setIps([...Ips, val])
    $("#ips").val('')
  }

  const submitIps = () => {
    let ips = {
      "subDomains": Ips
    }
    addSubdomains(id, dispatch, ips)
    setModalThree('')
    setIps([])
  }

  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1>DNS Records</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/" className="welcome-textSmall">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Details
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 text-right hidden-xs">
              <span className="mr-2">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setIsRecommendationModal(true);
                  }}
                  href="#"
                  style={{ float: "right" }}
                  className="btn btn-primary mr-1"
                >
                  Recommendation
                </a>  
              </span>
              {downloadCsvData?.length === 0 ? null : (
                <span>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      exportToCSV(downloadCsvData, "DNS Records");
                    }}
                    href="/add-report"
                    style={{ float: "right" }}
                    className="btn btn-primary mr-1"
                  >
                    <i className="fa fa-file-excel-o"></i> Download Details
                  </a>
                </span>
              )}
            </div>

          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        <div className="row clearfix">
          <div className="col-lg-4 col-md-12">
            <div className="card">
              {/* <div className="header">
                <h2>Details </h2>
              </div> */}
              <div className="body" style={{ minHeight: "410px" }}>
                <div>
                  <div className="row text-center">
                    <div className="col-12 pb-4 pt-12"></div>
                  </div>
                </div>
                <div>
                  <div className="form-group">
                    <label className="d-block">
                      Records found{" "}
                      <span className="float-right">
                        {mapData?.length || 0}
                      </span>
                    </label>
                    <div className="progress progress-xxs">
                      <div
                        className="progress-bar progress-bar-danger"
                        role="progressbar"
                        aria-valuenow={(
                          ((issuesFound?.length || 0) /
                            (dnsDetailsArray?.length || 0)) *
                          100
                        ).toFixed(0)}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width:
                            (
                              ((issuesFound?.length || 0) /
                                (dnsDetailsArray?.length || 0)) *
                              100
                            ).toFixed(0) + "%",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8 col-md-12">
            <div className="card">
              <div className="body" style={{ minHeight: "410px" }}>
                <span>Previous scan details</span>

                {/* <small className="text-muted">
                  Previous scan details between 
                </small> */}
                {/* <SalesChart /> */}
                {oldDnsDetails && (
                  <BasicLineColumn
                    dates={oldDnsDetails?.dates}
                    // openPortArray={openPortArray}
                    ipArray={ipArray}
                    color={["#ffd861", "#FF5A65"]}
                    yAxis={"IP Assets"}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-12 col-sm-12">
            <div className="card">
              <div className="body">
                <div className="header">
                  <h2>Details</h2>
                </div>
                <div className="row" ref={myRef}>
                  <div className="col-sm-4">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={filterData}
                      onChange={(e) => { setfilterData(e.target.value); setPage(1) }}
                    >
                      {distinctFilter?.map((row) => {
                        return (
                          <option value={row}>{row?.toUpperCase()}</option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      value={domainFilter}
                      onChange={(e) => { setDomainFilter(e.target.value); setPage(1) }}
                    >
                      <option value='all'>All</option>
                      {domain?.map((row, index) => {
                        return (
                          <option value={row}>{row?.toUpperCase()}</option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <div
                      data-test="datatable-input"
                      class="mdb-datatable-filter flex-row"
                    >
                      <input
                        class="form-control form-control-sm ml-0 my-1"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setPage(1);
                        }}
                      />
                    </div>
                  </div>


                </div>

                <div className="table-responsive">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        {/* <th>#No</th> */}
                        <th style={{ width: "100px" }}>Domain Name</th>
                        <th>Record Type</th>
                        <th style={{ width: "200" }}>Record</th>
                        <th>Last modified on</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTableData?.map((row, index) => {
                        // const pageCount = (page - 1) * 10 + 1;
                        return (
                          <tr>
                            {/* <td>{pageCount + index}</td> */}

                            {/* <td style={{ whiteSpace: "unset" }}>
                              <a
                                href={`${row?.subDomain || row?.subDomain}`}
                                target="_blank"
                              >
                                {row?.subDomain || row?.subDomain}
                              </a>
                            </td> */}
                            <td style={{ whiteSpace: "unset" }}>
                              <a href={`https://${row?.subDomain}`} target="_blank">
                                {`${row?.subDomain}`}
                              </a>
                            </td>
                            <td>{row?.recordType}</td>
                            <td style={{ whiteSpace: "unset" }}>
                              {row?.recordType == "MX"
                                ? row.valid
                                  ? row?.hosts?.map((req) => {
                                    return (
                                      <>
                                        <span>{req[0]?.hostname}</span>
                                        <br />
                                      </>
                                    );
                                  })
                                  : row?.warnings?.map((req) => {
                                    return (
                                      <>
                                        <span>{req?.hostname}</span>
                                        <br />
                                      </>
                                    );
                                  })
                                : row?.record}
                            </td>
                            <td style={{ whiteSpace: "unset" }}>
                              <span className="badge badge-success">
                                {moment(row?.updatedAt || row?.createdAt).format("DD-MM-YYYY")}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="dataTables_paginate">
                  {mapData && mapData.length > 0 && (
                    <Pagination
                      className="pagination-bar"
                      currentPage={page}
                      totalCount={mapData?.length}
                      pageSize={PageSize}
                      onPageChange={(page) => setPage(page)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModalThree === "Form Wizard modalThree" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add IP Address
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalThree("");
                    setIps([]);
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <div className="form-group d-flex">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Subdomains"
                            name="ips"
                            id="ips"
                            style={{ float: "left", width: "89%" }}
                          />
                          <button
                            type="button"
                            style={{ float: "left", marginLeft: '5px' }}
                            className="btn btn-primary"
                            onClick={() => addIps()}
                          >
                            <i
                              className="fa fa-plus"
                              style={{ fontSize: "22px", color: "black" }}
                            ></i>
                          </button>
                        </div>
                        {Ips && Ips.length > 0 && (
                          <div className="row">
                            {Ips?.map((keyword, index) => {
                              return (
                                <label
                                  key={index}
                                  style={{
                                    color: "white",
                                    background: "#43a5f5",
                                    padding: "4px 6px",
                                    margin: "5px 5px"
                                  }}
                                >
                                  <span>
                                    {keyword}{" "}
                                    <span
                                      className="fa fa-times-circle"
                                      onClick={() =>
                                        removeKeyword(index)
                                      }
                                    ></span>
                                  </span>
                                </label>
                              );
                            })}
                          </div>)}
                      </div>
                      <div className="col-md-12 text-center">
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          className="btn btn-round btn-primary mr-1"
                          onClick={() => {
                            submitIps()
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek has identified multiple active and inactive subdomains associated with
                  your organization. Unmonitored subdomains significantly expand the external
                  attack surface and can lead to subdomain takeover, data exposure, and shadow IT risks.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Is Subdomain Monitoring</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Subdomain monitoring continuously discovers, tracks, and classifies subdomains
                      linked to your primary domains, including active, inactive, and dangling entries.
                      Attackers actively target forgotten or misconfigured subdomains.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Key Risk Categories Observed</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li><strong>Active subdomains:</strong> Production systems exposed to the internet</li>
                      <li><strong>Inactive subdomains:</strong> Abandoned services still resolving in DNS</li>
                      <li><strong>Dangling subdomains:</strong> DNS entries pointing to decommissioned cloud resources</li>
                      <li><strong>Third-party hosted subdomains:</strong> SaaS, CDN, or vendor infrastructure</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Security & Business Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Subdomain takeover via cloud service reassignment</li>
                      <li>Unauthorized hosting of phishing or malware pages</li>
                      <li>Exposure of internal admin panels or test environments</li>
                      <li>Compliance violations due to unmanaged internet-facing assets</li>
                      <li>Increased attack surface for automated scanners and bots</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Landscape Insight</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Threat actors routinely scan DNS records to identify inactive or dangling
                      subdomains. Once identified, these are exploited to host phishing kits,
                      credential harvesters, or brand impersonation pages.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Risk Reduction</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Review all inactive subdomains for business necessity</li>
                      <li>Remove DNS records for unused or deprecated subdomains</li>
                      <li>Identify and remediate dangling subdomains immediately</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.9 · Asset Management</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Subdomain Takeover Prevention</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Verify cloud resources linked to DNS records exist</li>
                      <li>Reclaim or delete orphaned cloud services</li>
                      <li>Restrict wildcard DNS usage where possible</li>
                    </ul>
                    <div className="compliance-tag">OWASP Top 10 – Security Misconfiguration</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Operational Hardening</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Tag subdomains by environment (Prod / UAT / Dev)</li>
                      <li>Ensure TLS certificates for active subdomains</li>
                      <li>Disable directory listing and default pages</li>
                    </ul>
                    <div className="compliance-tag">NIST CSF PR.AC</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Continuous Monitoring & Governance</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enable continuous subdomain discovery</li>
                      <li>Track changes in IP, hosting, and DNS resolution</li>
                      <li>Periodically validate ownership of all subdomains</li>
                    </ul>
                    <div className="compliance-tag">CERT-In Continuous Attack Surface Monitoring</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Domain;
